import { createContext, useContext } from "react";
import { ModelStatus } from "@/components/flow/shared/ModelStatus/cms";
import {
    DataMode,
    WorkflowCredentialsType,
    RapidWorkflowDataType
} from "@/components/flow/shared/Deploy/documentation/types";
import {
    CreateRapidWorkflowApiErrorCB,
    CreateRapidWorkflowSuccessCB
} from "@/store/slices/workflowSlice";
import { CreateRapidWorkflowProps } from "@/store/slices/workflowSlice";

export type DeployContextType = {
    dataMode: DataMode;
    setDataMode: React.Dispatch<React.SetStateAction<DataMode>>;
    modelStatus: ModelStatus;
    workflowCredentials: WorkflowCredentialsType;
    workflow: RapidWorkflowDataType | null;
    setWorkflow: (workflow: RapidWorkflowDataType | null) => void;
    apiKey: string;
    loading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    creatingRapidWorkflow: boolean;
    setCreatingRapidWorkflow: (creating: boolean) => void;
    createRapidWorkflowDeploy: (
        props: CreateRapidWorkflowProps,
        onSuccess?: CreateRapidWorkflowSuccessCB,
        onError?: CreateRapidWorkflowApiErrorCB
    ) => Promise<RapidWorkflowDataType>;
};

export const DeployContext = createContext<DeployContextType>({} as DeployContextType);

export type DeployContextProviderValueType = Omit<DeployContextType, "setDataMode" | "setWorkflow">;

export const useDeployContext = () => {
    return useContext(DeployContext);
};
